import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_TOOLBOX = restRequest("TOOLBOX_PROFILE.GET_TOOLBOX_PROFILE");
export const SET_TOOLBOX = restRequest("TOOLBOX_PROFILE.SET_TOOLBOX");

export const UPLOAD_FILE = restRequest("TOOLBOX_PROFILE.UPLOAD_FILE");

export const SET_TOOLBOX_POINTS = restRequest(
    "TOOLBOX_PROFILE.SET_TOOLBOX_POINTS"
);
export const GET_TOOLBOXTYPE_LIST = restRequest(
    "TOOLBOX_PROFILE.GET_TOOLBOXTYPE_LIST"
);
